export default "__VITE_ASSET__Dty57yol__"